import React, { useState } from "react";
import { Container } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import AgentControlMetrics from "./AgentControlMetrics";
import AgentControlTable from "./AgentControlTable";

const AgentControl = () => {
  document.title = "Agent Control";

  // Metrics passes wazuh agents up so the table can optionally use them
  const [, setWazuhAgents] = useState([]);

  return (
    <div className="page-content" style={{ background: "#f8fafc", minHeight: "100vh" }}>
      <Container fluid style={{ maxWidth: 1400, padding: "24px 20px" }}>

        {/* ── Page header ──────────────────────────────────────── */}
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <div style={{
                width: 34, height: 34, borderRadius: 9,
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <FeatherIcon icon="server" size={17} style={{ color: "#d87844" }} />
              </div>
              <h4 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#1e293b" }}>
                Agent Control
              </h4>
            </div>
            <p style={{ margin: 0, fontSize: 13, color: "#94a3b8" }}>
              Monitor endpoint health, manage services, and track connection history
            </p>
          </div>

          {/* Live indicator */}
          <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 20, fontSize: 12, color: "#64748b" }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#16a34a", boxShadow: "0 0 0 2px #bbf7d0", animation: "pulse 2s infinite" }} />
            Live monitoring
            <style>{`@keyframes pulse { 0%,100%{box-shadow:0 0 0 2px #bbf7d0} 50%{box-shadow:0 0 0 5px #bbf7d024} }`}</style>
          </div>
        </div>

        {/* ── Metrics row ──────────────────────────────────────── */}
        <AgentControlMetrics onAgentsLoaded={setWazuhAgents} />

        {/* ── Divider ──────────────────────────────────────────── */}
        <div style={{ height: 1, background: "#e2e8f0", marginBottom: 20 }} />

        {/* ── Agent table / cards ──────────────────────────────── */}
        <AgentControlTable />

      </Container>
    </div>
  );
};

export default AgentControl;